import { HeatPumpFormModel } from './heat-pump/heatPumpFormModel';
import { SolarFormModel } from './solar/solarFormModel';

export const unitFieldName = (unitIndex: number, fieldName: string) => `units.${unitIndex}.${fieldName}`;

export const manifoldFieldName = (unitIndex: number, manifoldIndex: number, fieldName: string) =>
  `${unitFieldName(unitIndex, `manifolds`)}.${manifoldIndex}.${fieldName}`;

export const roomFieldName = (unitIndex: number, manifoldIndex: number, roomIndex: number, fieldName: string) =>
  `${manifoldFieldName(unitIndex, manifoldIndex, `rooms`)}.${roomIndex}.${fieldName}`;

export const heatPumpFieldName = (unitIndex: number, fieldName: keyof HeatPumpFormModel) =>
  `${unitFieldName(unitIndex, `heatPump`)}.${fieldName}`;

export const heatPumpUnitFieldName = (unitIndex: number, heatPumpUnitIndex: number) =>
  `${unitFieldName(unitIndex, 'heatPump.heatPumpUnitParts')}.${heatPumpUnitIndex}`;

export const solarFieldName = (unitIndex: number, fieldName: keyof SolarFormModel) =>
  `${unitFieldName(unitIndex, 'solar')}.${fieldName}`;
